import React from "react";
import CheckboxListControl from "./CheckboxListControl";
import Field from "./Field";
import { CheckboxListFieldProps } from "./Types";

const CheckboxListField: React.FC<CheckboxListFieldProps> = ({ labelProps, controlProps, visible, disabled, layout, options }) => {

    if (visible === false)
        return <></>;

    return (
        <Field {...labelProps}>
            <CheckboxListControl {...controlProps} layout={layout} options={options} disabled={disabled} />
        </Field>
    );
}
export default CheckboxListField;